import Menu from './menu-item';

const toggleTriggers = document.querySelectorAll('.md-menu-toggle');

/* Toggle search box */
toggleTriggers.forEach((el) => {
  el.addEventListener('click', (e) => {
   e.preventDefault();
   Menu.toggle();
  });
});




// WEBPACK FOOTER //
// ./resources/assets/js/menu.js